import React from 'react';
import { useParams } from 'react-router-dom';

const POLICIES = {
  privacy: {
    title: 'Privacy Policy',
    content: `
Last updated: May 2025

**1. Information We Collect**
We collect information you provide directly to us when you create an account, make a purchase, or contact us. This includes: name, email address, phone number, shipping address, and payment information (processed securely by Razorpay).

**2. How We Use Your Information**
We use your information to: process orders and payments, deliver products, send order updates via email/SMS, improve our services, and comply with legal obligations.

**3. Information Sharing**
We share your information only with: payment processors (Razorpay), shipping partners (Delhivery), and as required by law. We do not sell your personal data.

**4. Data Security**
We implement appropriate security measures including SSL encryption and secure payment processing to protect your information.

**5. Cookies**
We use cookies to maintain your session and improve your shopping experience.

**6. Contact Us**
For privacy concerns, contact us at: stonariofficial@gmail.com
    `,
  },
  returns: {
    title: 'Return & Refund Policy',
    content: `
**Return Window:** 7 days from delivery date.

**Eligible for Return:**
- Defective or damaged products
- Wrong item received
- Product significantly different from description

**Not Eligible for Return:**
- Used or worn items
- Items without original packaging
- Custom or personalized orders

**Return Process:**
1. Email us at stonariofficial@gmail.com within 7 days
2. Include your Order ID and photos of the issue
3. We will arrange a pickup within 2-3 business days
4. Refund processed within 5-7 business days after product verification

**Refund Method:** Original payment method (Razorpay). Cash on Delivery orders refunded via bank transfer.
    `,
  },
  shipping: {
    title: 'Shipping & Delivery Policy',
    content: `
**Shipping Partners:** We ship via Delhivery across India.

**Shipping Charges:**
- Orders above ₹499: FREE shipping
- Orders below ₹499: ₹60 flat shipping charge

**Delivery Timeline:**
- Metro cities: 3-5 business days
- Other cities: 5-7 business days
- Remote areas: 7-10 business days

**Order Processing:**
- Orders are processed within 1-2 business days
- You will receive a tracking number once shipped

**Tracking:**
Track your order using your Order ID on our tracking page or directly on the Delhivery website.

**Failed Delivery:**
If delivery fails, Delhivery will attempt 2 more deliveries. After that, the package returns to us.
    `,
  },
  terms: {
    title: 'Terms & Conditions',
    content: `
By using stonariofficial.in, you agree to these terms.

**1. Products**
All product images are for reference. Slight color variations may occur due to screen settings.

**2. Pricing**
All prices are in Indian Rupees (INR) and inclusive of applicable taxes.

**3. Orders**
We reserve the right to cancel orders in case of stock unavailability or suspected fraud.

**4. Payments**
Payments are processed securely via Razorpay. We do not store card details.

**5. Intellectual Property**
All content on this website is the property of Stonari Official. Unauthorized use is prohibited.

**6. Governing Law**
These terms are governed by the laws of India.

**Contact:** stonariofficial@gmail.com
    `,
  },
};

const PoliciesPage = () => {
  const { type } = useParams();
  const policy = POLICIES[type] || POLICIES.privacy;

  const renderContent = (text) =>
    text.trim().split('\n').map((line, i) => {
      if (line.startsWith('**') && line.endsWith('**')) {
        return <h3 key={i} style={{fontFamily:'Cormorant Garamond,serif',fontSize:'1.2rem',marginTop:'24px',marginBottom:'8px'}}>{line.replace(/\*\*/g,'')}</h3>;
      }
      if (line.startsWith('- ')) {
        return <li key={i} style={{marginLeft:'20px',marginBottom:'4px',fontSize:'14px',color:'#4a4a4a'}}>{line.slice(2)}</li>;
      }
      if (line.match(/^\d\./)) {
        return <p key={i} style={{marginBottom:'8px',fontSize:'14px',color:'#4a4a4a'}}>{line}</p>;
      }
      return line.trim() ? <p key={i} style={{marginBottom:'12px',fontSize:'14px',color:'#4a4a4a',lineHeight:'1.8'}}>{line}</p> : null;
    });

  return (
    <div style={{paddingTop:'72px'}}>
      <div className="page-header"><h1>{policy.title}</h1></div>
      <div className="container">
        <div style={{maxWidth:'720px',margin:'48px auto 80px',padding:'0 24px'}}>
          {renderContent(policy.content)}
        </div>
      </div>
    </div>
  );
};

export default PoliciesPage;
